import * as React from 'react'
import { NextButton } from '../../../../../shared/components/Button'
import { HeadlineCSS } from '../../../../../shared/components/Headlines'
import { breakpoint, css, styled } from '../../../../../shared/styled-components'
import { Utils } from '../../../../../shared/Utils'
import { ifProp, prop, switchProp } from 'styled-tools'

type TLayout = 'white' | 'green' | 'dark'

interface IProps {
  layout: TLayout
  name: string
  percentage: number
  price: number
  selfExpense: number
  link: string
  recommended?: boolean
}

export const Insurance = (props: IProps) => {
  const { layout, name, percentage, selfExpense, price, link, recommended } = props
  return (
    <Container {...{ layout }}>
      {recommended && (
        <RecommendationBadge>
          <RecommendationImage src={Utils.getAssetPath('/assets/calculator/result/insurance_recommended.svg')} />
        </RecommendationBadge>
      )}
      <Box {...{ layout }}>
        <Name {...{ layout }}>{name}</Name>

        <RefundPercentage>{percentage}%</RefundPercentage>
        <RefundText>Erstattung auf Ihren Eigenanteil</RefundText>

        <OwnExpenseContainer {...{ layout }}>
          <div>Ihr Eigenanteil:</div>
          <OwnExpense>{Utils.formatAmount(selfExpense - (selfExpense * percentage) / 100, 0)} &euro;</OwnExpense>
        </OwnExpenseContainer>

        <Price>ab {price} &euro; pro Monat</Price>
      </Box>

      <Buttons>
        <Button outlined target="_blank" href={link} {...{ layout }}>
          unverbindlich beraten lassen
        </Button>
        <Button target="_blank" href={link} {...{ layout }}>
          online abschließen
        </Button>
      </Buttons>
    </Container>
  )
}

const OwnExpenseContainer = styled.div`
  padding-top: 25px;
`

const Container = styled.div<{ layout?: TLayout }>`
  position: relative;
  flex: 1;
  border-radius: 3px;
  text-align: center;
`

const contrastStyles = css`
  background: ${switchProp('layout', {
    white: 'white',
    green: prop('theme.greenColor'),
    dark: prop('theme.darkBlueColor'),
  })};
  color: ${switchProp('layout', {
    white: prop('theme.blueColor'),
    green: prop('theme.blueColor'),
    dark: prop('theme.greenColor'),
  })};
  padding-top: 22px;
`

const Box = styled.div<{ layout?: TLayout }>`
  color: white;
  border: 2px solid
  border-radius: 10px;
    ${switchProp('layout', {
      white: 'white',
      green: prop('theme.greenColor'),
      dark: prop('theme.darkBlueColor'),
    })};
  margin-bottom: 1rem;
  border-color: ${switchProp('layout', {
    white: 'white',
    green: prop('theme.greenColor'),
    dark: prop('theme.darkBlueColor'),
  })};
  @media (max-width: 950px) {
    width: 500px;
    margin: 0 auto;
    margin-top: 50px;
  }
  @media (max-width: 600px) {
    width: calc(100vw - 40px);
  }
`

const Name = styled.div`
  ${HeadlineCSS};
  font-size: 30px;
  border-radius: 8px 8px 0 0;
  margin-bottom: 10px;
  color: inherit;
  ${breakpoint('tablet')`
    font-size: 40px;
    margin-bottom: 20px;
  `}
  @media (max-width: 600px) {
    font-size: 20px;
    padding: 10px 0;
  }

  ${contrastStyles};
`

const RefundPercentage = styled.div<{ gold?: boolean }>`
  font-size: ${(props) => (props.gold ? '75px' : '50px')};
  @media (max-width: 600px) {
    font-size: 40px;
  } 
`
const RefundText = styled.div`
  font-size: 16px;
  line-height: 20px;
  margin: auto;
  padding-bottom: 40px;
`

const OwnExpense = styled.div`
  font-size: 30px;
  margin-top: 10px;
  padding: 0 0 20px 0;
`

const Price = styled.div`
  font-size: 22px;
  margin-top: 25px;
  margin-bottom: 20px;
  text-decoration: underline;
  padding: 20px 0;
`

const RecommendationBadge = styled.div`
  position: absolute;
  top: -20px;
  right: -10px;
  border-radius: 3px;
  color: white;
  text-transform: uppercase;
  display: flex;
  @media (max-width: 950px) {
    width: 500px;
    position: relative;
    margin: 0 auto;
    margin-bottom: -40px;
  }
 @media (max-width: 600px) {
    width: calc(100vw - 40px);
    margin-bottom: -90px;
  }
`

const RecommendationImage = styled.img`
  width: 35px;
  margin-right: 10px;
`

const OwnExpenseContainer = styled.div`
  ${contrastStyles};
`

const Button = styled.a<{ layout: TLayout; outlined?: boolean }>`
  ${contrastStyles};

  ${ifProp(
    'outlined',
    css`
      border: 2px solid
        ${switchProp('layout', {
          white: 'white',
          green: prop('theme.greenColor'),
          dark: prop('theme.darkBlueColor'),
        })};
      background: transparent;
      color: ${switchProp('layout', {
        white: 'white',
        green: prop('theme.greenColor'),
        dark: prop('theme.greenColor'),
      })};
    `
  )};
  margin-bottom: 1rem;
  padding: 10px 0;
  border-radius: 8px;
  margin: 20px 0;
  @media (max-width: 950px) {
    width: 500px;
    margin: 10px auto;
  }
  @media (max-width: 600px) {
    width: calc(100vw - 40px);
  }
`

const Buttons = styled.div`
  display: flex;
  flex-direction: column;
`
